import t from "react";
import { useTheme as m, Box as g, Rating as u, Typography as h } from "@mui/material";
function b(e) {
  const n = m(), l = {
    0: "0",
    0.5: "0.5",
    1: "1",
    1.5: "1.5",
    2: "2",
    2.5: "2.5",
    3: "3",
    3.5: "3.5",
    4: "4",
    4.5: "4.5",
    5: "5"
  }, [a, i] = t.useState(-1), { hoverFeedback: o, ...r } = e, c = () => o ? l[a !== -1 ? a : e.value ? e.value : 0] : e.label;
  return /* @__PURE__ */ t.createElement(g, { display: "flex", alignItems: "center", gap: n.spacing(2) }, /* @__PURE__ */ t.createElement(
    u,
    {
      ...r,
      precision: e.precision ? 0.5 : 1,
      size: e.size === "small" ? "small" : "medium",
      onChangeActive: (v, s) => {
        i(s);
      },
      onChange: e.onChange,
      onBlur: e.onBlur
    }
  ), /* @__PURE__ */ t.createElement(
    h,
    {
      fontSize: e.size === "small" ? 14 : 16,
      color: e.disabled ? n.palette.grey[400] : void 0
    },
    c()
  ));
}
export {
  b as R
};
